import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../../types";
import { getApi } from "../../../apiPath";
import { axiosClient } from "../../../clients";

import type { ILaboratoryStudents } from "./routeType";

const { key, getPath } = getApi("members.laboratories.students.get");

type IExtractedRouteType =
  ILaboratoryStudents["laboratoryStudentSingleRetrieve"];

export type IGetMemberLaboratoryStudent = IPickSingleQuery<IExtractedRouteType>;

const getMemberLaboratoryStudent: Fetcher<
  IGetMemberLaboratoryStudent["response"],
  IGetMemberLaboratoryStudent["variables"]
> = ({ labId, studentId, ...params }) => {
  return axiosClient.get(getPath({ labId, studentId }), { params });
};

export const useGetMemberLaboratoryStudent = createQuery({
  queryKey: [key],
  fetcher: getMemberLaboratoryStudent,
});
